import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { SimpleErrors } from '@simonbackx/simple-errors';
import { v4 as uuidv4 } from "uuid";
export var DNSRecordType;
(function (DNSRecordType) {
    DNSRecordType["CNAME"] = "CNAME";
    DNSRecordType["TXT"] = "TXT";
})(DNSRecordType || (DNSRecordType = {}));
export var DNSRecordStatus;
(function (DNSRecordStatus) {
    DNSRecordStatus["Pending"] = "Pending";
    DNSRecordStatus["Failed"] = "Failed";
    DNSRecordStatus["Valid"] = "Valid";
})(DNSRecordStatus || (DNSRecordStatus = {}));
export class DNSRecord extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.status = DNSRecordStatus.Pending;
        this.errors = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], DNSRecord.prototype, "id", void 0);
__decorate([
    field({ decoder: new EnumDecoder(DNSRecordType) })
], DNSRecord.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder })
], DNSRecord.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], DNSRecord.prototype, "value", void 0);
__decorate([
    field({ decoder: new EnumDecoder(DNSRecordStatus) })
], DNSRecord.prototype, "status", void 0);
__decorate([
    field({ decoder: DateDecoder, defaultValue: () => new Date() })
], DNSRecord.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: SimpleErrors, nullable: true, version: 7 })
], DNSRecord.prototype, "errors", void 0);
//# sourceMappingURL=DNSRecord.js.map